import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RealEstateLocation } from '@immosky/types';

@Component({
  selector: 'lib-location-display',
  templateUrl: './location-display.component.html',
  styleUrls: ['./location-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationDisplayComponent {
  @Input()
  location!: RealEstateLocation;
}
